import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { EscuelasParticipantesDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class EscuelasParticipantesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getEscuelasParticipantesService(): Observable<
    BodyListResponse<EscuelasParticipantesDTO>
  > {
    return this.http.get<BodyListResponse<EscuelasParticipantesDTO>>(
      API_URL + '/api/v1/escuelasParticipantes/todos',
    );
  }

  getEscuelasParticipantesPorProuectoService(
    codigo: string,
  ): Observable<BodyListResponse<EscuelasParticipantesDTO>> {
    return this.http.get<BodyListResponse<EscuelasParticipantesDTO>>(
      API_URL + '/api/v1/escuelasParticipantes/todos/proyecto/' + codigo,
    );
  }

  guardarEscuelasParticipantesService(
    escuelasParticipantesDTO: EscuelasParticipantesDTO,
  ): Observable<BodyResponse<EscuelasParticipantesDTO>> {
    return this.http.post<BodyResponse<EscuelasParticipantesDTO>>(
      API_URL + '/api/v1/escuelasParticipantes',
      escuelasParticipantesDTO,
    );
  }

  getEscuelasParticipantesPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<EscuelasParticipantesDTO>> {
    return this.http.get<BodyResponse<EscuelasParticipantesDTO>>(
      API_URL + '/api/v1/escuelasParticipantes/' + codigo,
    );
  }
}
